import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLSlotElement extends HTMLElement { constructor(tagName: string = 'SLOT', ownerDocument?: any) { super(tagName, ownerDocument); } }
